import { animate, state, style, transition, trigger } from '@angular/animations';

/** Angular animation that turn over applied element. Mostly used for dropdown arrows. */
export const TURN_OVER_ANIMATION = trigger('turnOver', [
  state(
    'level',
    style({
      transform: 'rotateX(0deg)',
    }),
  ),
  state(
    'turned',
    style({
      transform: 'rotateX(180deg)',
    }),
  ),
  transition('level <=> turned', [animate('0s ease-in')]),
]);


export const EXPAND_COLLAPSE_ANIMATION =
  trigger('expandCollapsePanel', [
    state(
      'void',
      style({
        height: '0px',
      }),
    ),
    // Element being added into DOM.
    transition(':enter', [
      animate(
        '300ms ease-in-out',
        style({
          height: '*',
          opacity: 1
        }),
      ),
    ]),
    // Element being removed from DOM.
    transition(':leave', [
      animate(
        '300ms ease-in-out',
        style({
          height: '0px',
          opacity: 0,
        }),
      ),
    ]),
  ]);
